/**
 * Diese Funktion tut nichts. Kann verwendet werden, wenn eine Funktion
 * erwartet wird, aber nichts wirklich passieren soll.
 * Z. B. zum Abfangen von Fehlern von Promises, da ESLint sonst meckert.
 */
export function noop (...args: unknown[]): unknown[] { return args }
